/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Changes the unsellable verdict on a quote that already carries one: \[unsellable\] false reverts it, true rewrites the \[reason\]. Both need a reason; only a revert needs \[confirmedWithCarrier\], because taking the verdict back is a fresh claim about what the carrier said. Rewriting the reason leaves the verdict, and its original confirmation, standing. A revert leaves the quote hidden unless \[makeVisible\] is set, which shows it in the same action and obeys the ordinary show rules --- so a Benchmark quote is still refused.
 * @export
 * @interface SetQuoteUnsellableBody
 */
export interface SetQuoteUnsellableBody {
  /**
   *
   * @type {boolean}
   * @memberof SetQuoteUnsellableBody
   */
  unsellable: boolean;
  /**
   *
   * @type {string}
   * @memberof SetQuoteUnsellableBody
   */
  reason: string;
  /**
   *
   * @type {boolean}
   * @memberof SetQuoteUnsellableBody
   */
  makeVisible: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SetQuoteUnsellableBody
   */
  confirmedWithCarrier: boolean;
}

/**
 * Check if a given object implements the SetQuoteUnsellableBody interface.
 */
export function instanceOfSetQuoteUnsellableBody(
  value: object,
): value is SetQuoteUnsellableBody {
  if (!("unsellable" in value) || value["unsellable"] === undefined)
    return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  if (!("makeVisible" in value) || value["makeVisible"] === undefined)
    return false;
  if (
    !("confirmedWithCarrier" in value) ||
    value["confirmedWithCarrier"] === undefined
  )
    return false;
  return true;
}

export function SetQuoteUnsellableBodyFromJSON(
  json: any,
): SetQuoteUnsellableBody {
  return SetQuoteUnsellableBodyFromJSONTyped(json, false);
}

export function SetQuoteUnsellableBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetQuoteUnsellableBody {
  if (json == null) {
    return json;
  }
  return {
    unsellable: json["unsellable"],
    reason: json["reason"],
    makeVisible: json["makeVisible"],
    confirmedWithCarrier: json["confirmedWithCarrier"],
  };
}

export function SetQuoteUnsellableBodyToJSON(
  json: any,
): SetQuoteUnsellableBody {
  return SetQuoteUnsellableBodyToJSONTyped(json, false);
}

export function SetQuoteUnsellableBodyToJSONTyped(
  value?: SetQuoteUnsellableBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    unsellable: value["unsellable"],
    reason: value["reason"],
    makeVisible: value["makeVisible"],
    confirmedWithCarrier: value["confirmedWithCarrier"],
  };
}
